const FAQS = [
  {
    q: "Where do you operate?",
    a: "We operate in all nine provinces across South Africa - from major cities to surrounding towns.",
  },
  {
    q: "How fast can I get a quote?",
    a: "Most quotes are ready in under 30 seconds. Enter your pickup and drop-off, choose a vehicle, and see your all-in price instantly.",
  },
  {
    q: "What's included in the price?",
    a: "Your quote includes the truck, driver, and fuel. A helper is included on most bookings. No hidden fees at checkout.",
  },
  {
    q: "Can I pay after the job?",
    a: "Yes. Pay online when you book, when the job starts, or after delivery - by card, EFT, or cash where accepted.",
  },
  {
    q: "Are drivers vetted?",
    a: "Every driver and vehicle goes through document checks, inspections, and background screening before joining the platform.",
  },
  {
    q: "Is my load insured?",
    a: "Goods-in-transit cover is available. Contact support@qiktruck.co.za for details on insurance options for your shipment.",
  },
];

export default FAQS;
